import React, { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header  from './Header';
import { dashboardAPI } from '../../services/api';

export const YearContext = React.createContext({ yearId: 3, yearLabel: '2026-27', setYear: () => {} });

export default function Layout() {
  const [collapsed, setCollapsed]   = useState(false);
  const [yearId,    setYearId]      = useState(3);
  const [years,     setYears]       = useState([]);
  const [refreshKey,setRefreshKey]  = useState(0);

  useEffect(() => {
    dashboardAPI.getAcademicYears()
      .then(r => {
        setYears(r.data);
        const current = r.data.find(y => y.is_current);
        if (current) setYearId(current.id);
      })
      .catch(() => {});
  }, []);

  const handleRefresh = useCallback(() => setRefreshKey(k => k + 1), []);

  const sidebarWidth = collapsed ? 72 : 260;

  return (
    <YearContext.Provider value={{ yearId, setYear: setYearId, refreshKey }}>
      <div className="min-h-screen bg-primary-50">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />

        <div
          className="transition-all duration-300 ease-in-out"
          style={{ marginLeft: sidebarWidth }}
        >
          <Header
            onRefresh={handleRefresh}
            academicYear={yearId}
            onYearChange={setYearId}
            years={years}
            sidebarWidth={sidebarWidth}
          />

          <main className="pt-16 min-h-screen">
            <div className="p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </YearContext.Provider>
  );
}
